import { useAuthContext } from "../../../../../../context/AuthContext";
import useBasicColumnConfig from "./BasicColumnConfig";

/**
 * @param {string} key
 * @param {function(row) : any} data default value is (row) => row[key]
 * @returns
 */
function useCompanyColumnConfig() {
  const { auth } = useAuthContext();

  return useBasicColumnConfig("company.name").setHidden(
    auth.user?.company?.type !== "business_center"
  );
}

export default useCompanyColumnConfig;
